import React, { useState } from "react";
import FormSelect from "../FormSelect/FormSelect";
import "./page-size-select.scss";

type PageSizeSelectProps = {
  value: string;
  options?: Array<{ value: string; label: string }>;
  onChange?: (val: string | null) => void;
  name?: string;
  label?: string;
  disable?: boolean;
  className?: string;
};

const pageSizeOptions = [
  { value: "5", label: "5" },
  { value: "10", label: "10" },
  { value: "25", label: "25" },
  { value: "50", label: "50" },
];

const PageSizeSelect = (props: PageSizeSelectProps) => {
  const {
    value,
    label = "",
    name = "",
    onChange = () => {},
    options = pageSizeOptions,
    disable = false,
  } = props;

  const [pageSize, setPageSize] = useState(String(value));

  const handleChange = (value: string | null) => {
    setPageSize(value as string);
    onChange(value);
  };

  return (
    <div
      className="d-flex column-gap-2 justify-content-end page-size-select"
      id="page-size-selector"
    >
      <div className="my-auto page-size-label">Page Size:</div>
      <FormSelect
        label={label}
        name={name}
        onChange={handleChange}
        options={options}
        value={pageSize}
        labelClassName="m-0 fw-500"
        isDisabled={disable}
        className={`${disable && "page-size-select-disable"}`}
      />
    </div>
  );
};

export default PageSizeSelect;
